import { override } from "mobx";
import { MrbBaseRouteStore } from "mrb/core";
import { PaymentService, ProductService, UserSettingsService, CouponService } from "common/services";

class TakePaymentRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(PaymentService);
        this.productService = rootStore.createApplicationService(ProductService);
        this.userSettingsService = rootStore.createApplicationService(UserSettingsService);
        this.couponService = rootStore.createApplicationService(CouponService);
    }

    @override
    onBeforeEnter(fromState, toState) {
        const subscriptionPlanId = toState.params.planId;
        const subscription =
            this.rootStore.premiumSubscriptionStore.getSubscriptionBySubscriptionPlan(subscriptionPlanId);
        if (subscription) {
            return Promise.reject("master.application.premium.subscriptions");
        }
        return Promise.resolve();
    }

    async getSubscriptionPlan(planId) {
        const response = await this.productService.getSubscription(planId);
        return response.data;
    }

    async setupPaymentMethodRequest() {
        const response = await this.service.setupPaymentMethodRequest();
        return response.data;
    }

    async getCertifiedModes() {
        const response = await this.userSettingsService.getCertifiedMode();
        return response.data;
    }

    async updateCertifiedMode(certifiedModeId, whitelistMode) {
        const response = await this.userSettingsService.updateCertifiedMode(certifiedModeId, whitelistMode);
        return response.data;
    }

    preprocessPayment(planId, promoCode) {
        return this.rootStore.premiumSubscriptionStore.preprocessPayment(planId, promoCode);
    }

    postprocessPayment(subscriptionId) {
        return this.rootStore.premiumSubscriptionStore.postprocessPayment(subscriptionId);
    }

    subscribeUsingExistingPaymentMethod(planId, promoCode) {
        return this.rootStore.premiumSubscriptionStore.subscribeUsingExistingPaymentMethod(planId, promoCode);
    }

    async validatePromoCode(promoCode, subscriptionProductId) {
        const response = await this.couponService.validatePromoCode(promoCode, subscriptionProductId);
        return response.data;
    }
}

export default TakePaymentRouteStore;
